import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bee237c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "preloader-wrapper",
  class: "w-screen h-screen fixed top-0 left-0 z-50 bg-brand-green-dark"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "top",
  class: "h-[calc(50%+0.25rem)] absolute top-0 left-0 w-screen bg-brand-green-dark"
}, null, -1))
const _hoisted_3 = {
  id: "logo",
  class: "w-32 md:w-48 2xl:w-60 absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 flex items-center justify-center"
}
const _hoisted_4 = {
  id: "preloader",
  class: "flex flex-col items-center justify-center gap-2 w-full absolute top-[55%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50"
}
const _hoisted_5 = {
  id: "percent",
  class: "text-white tracking-wide"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "bar",
  class: "rounded-md h-1 w-4/5 md:max-w-xs xl:max-w-lg bg-brand-black",
  "data-test": "bar"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "barconfirm",
    class: "h-full rounded-md bg-brand-green",
    "data-test": "barconfirm"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "bottom",
  class: "h-[calc(50%+0.25rem)] absolute -bottom-1 left-0 w-screen bg-brand-green-dark"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_logo)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.percent) + "%", 1),
      _hoisted_6
    ]),
    _hoisted_7
  ]))
}